
    import {computed, ComputedRef, defineComponent, reactive, onMounted, toRefs, watch} from 'vue'
    import {useStore} from "@/store";
    import swiperComponent from "./swiperComponent.vue";
    import { Tab, Tabs } from 'scvant';



    interface State {
        clientHeight: number; // 当前视窗高度
        modelName: string; // 车型名称
        photoList: object[]; // 当前展示的照片列表
        isShowSwiper: boolean; // 是否展示轮播图组件
        backFun: string; // 导航返回点击方法
        // swiperPhotoList: object[]; // 展示轮播图时的照片合集
        initialSlideSwiper: number; // 设定初始化时slide的索引
        initialSlideAll: number;
        isAll: boolean;
    }

    export default defineComponent({
        name: "photoListAll",
        props: {
            backFun: {
                type: String,
                default: ''
            },
            initialSlide: {
                type: Number,
                default: 0
            },
            tabName: {
                type: String,
                default: 'basePhoto'
            },
            noImg: {
                type: Number,
                default: 0
            },
            swiperPhotoList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            imgListLen: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        setup(props: any, ctx: any) {
            let state: State = reactive({
                clientHeight: 0,
                modelName: '',
                photoList: [],
                isShowSwiper: true,
                backFun:'',
                initialSlideSwiper: 0,
                initialSlideAll: 0,
                isAll: false
            })
            const {initialSlide, imgListLen} = toRefs(props);
            const store = useStore()
            function slideChange (data: any) {
                ctx.emit('slideChange', data);
            }
            
            // 获取当前设备高度用于设置黑色背景高度
            onMounted(() => {
                
                watch(imgListLen, (data) => {
                    // console.log('imgListLen_All:', imgListLen.value);
                }, {immediate: true})
                // watch(initialSlide, (data) => {
                //     state.initialSlideAll =  initialSlide.value;
                //     console.log('photoListAll--initialSlide:', initialSlide.value);
                //     state.initialSlideSwiper = state.initialSlideAll;
                // })
                state.clientHeight = document.documentElement.clientHeight;
            })
            return {
                state,
                slideChange
            }
        },
        methods: {
            goPhoto() {
                this.$emit('allPhont', this.state.isAll)
            }
        },
        components: {
            swiperComponent,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        }
    })
